import axios from "axios";
import { API } from "@/config";

export const adminApi = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
adminApi.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || adminApi.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return adminApi(cfg);
      } catch (e) {
        /* fall through to original error */
      }
    }
    return Promise.reject(err);
  }
);

export function formatError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? "Bir hata oluştu. Lütfen tekrar deneyin." : "Sunucuya ulaşılamadı. Bağlantınızı kontrol edin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : "")).filter(Boolean).join(" ");
  if (typeof d.message === "string") return d.message;
  return String(d);
}

const intl = (raw) => {
  const d = raw.replace(/\D/g, "");
  if (raw.trim().startsWith("+")) return d;
  if (d.startsWith("00")) return d.slice(2);
  if (d.startsWith("0")) return `90${d.slice(1)}`;
  if (d.length === 10) return `90${d}`;
  return d;
};

export const rules = {
  phone: (v) => /^90[2-5]\d{9}$/.test(intl(v)) || "Geçerli bir Türkiye numarası girin (örn. +90 216 123 45 67).",
  whatsapp: (v) => /^905\d{9}$/.test(intl(v)) || "Geçerli bir Türkiye cep numarası girin (örn. +90 532 123 45 67).",
  instagram: (v) => /^@?[A-Za-z0-9._]{1,30}$/.test(v) || /^https:\/\/(www\.)?instagram\.com\/[A-Za-z0-9._]{1,30}\/?$/.test(v) || "Kullanıcı adı (@woodia) veya https://instagram.com/... adresi girin.",
  url: (v) => /^https:\/\/[^\s/$.?#][^\s]*$/.test(v) || "https:// ile başlayan geçerli bir bağlantı girin.",
  email: (v) => /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(v) || "Geçerli bir e-posta adresi girin.",
};

export const clean = (f) => ({ value: typeof f.value === "string" && f.value.trim() === "" ? null : typeof f.value === "string" ? f.value.trim() : f.value, verified: !!f.verified });

export function checkField(f, rule) {
  const v = typeof f?.value === "string" ? f.value.trim() : "";
  if (!v || !rule) return null;
  const r = rule(v);
  return r === true ? null : r;
}

export const cleanBi = (f) => ({ ...clean(f), en: clean(f?.en || { value: null, verified: false }) });
